import { Text, Title, Section as BaseSection } from '../../utils/theme';
import styled, { keyframes } from 'styled-components';

const bobbing = keyframes`
  0%, 100% {
    transform: translateY(0vw);
  } 
  50% {
    transform: translateY(2vw);
  }
`;

const sliding = keyframes`
  0%, 100% {
    transform: translateX(0vw);
  } 
  50% {
    transform: translateX(-2vw);
  }
`;

const pulsing = keyframes`
  0%, 100% {
    transform: scale(1);
  } 
  50% {
    transform: scale(1.1);
  }
`;

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  overflow: hidden;
  height: 73vw;

  @media (max-width: 1050px) {
    height: 67vw;
  }

  @media (max-width: 600px) {
    height: 120vw;
  }
`;

export const AboutTitle = styled(Title)`
  position: absolute;   
  left: 55vw;
  top: 0vw;
  font-size: 3vw;
  text-align: left;
  @media (max-width: 600px) {
    left: 10vw;
    top: 5vw;
    width: 80vw;
    font-size: 6.5vw;
  }
`;

export const AboutText = styled(Text)`
  position: absolute;   
  left: 55vw;
  top: 10vw;
  width: 33vw;
  font-size: 1.25vw;
  text-align: left;

  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
    font-size: 3.5vw;
    left: 10vw;
    top: 30vw;
    width: 80vw;
  }
`;

export const BoldAboutText = styled(Text)`  
  position: absolute;   
  left: 55vw;
  top: 20vw;
  width: 35vw;
  font-size: 1.5vw;
  font-weight: bold;
  text-align: left;

  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
    font-size: 3.5vw;
    left: 10vw;
    top: 70vw;
    width: 80vw;
    font-size: 3.5vw;
  }
`;

export const WaveThemeImage = styled.img`
  position: absolute;
  left: 0vw;
  width: 100vw;
  top: -5vw;

  animation: ${sliding} 15s ease-in-out infinite;

  @media (max-width: 600px) {
    z-index: -1;
    position: absolute;
    top: 55vw;
    left: 0vw;
    width: 100vw;
  }
`;

export const GhostCharacter2Image = styled.img`
  position: absolute;
  top: 0vw;
  left: 5vw;
  width: 14vw;

  animation: ${bobbing} 5s ease-in-out infinite;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const PinkCharacter2Image = styled.img`
  position: absolute;
  top: 10vw;
  left: 20vw;
  width: 14vw;

  animation: ${bobbing} 7.2s ease-in-out -3.3s infinite;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const LettuceCharacterImage = styled.img`
  position: absolute;
  top: 12vw;
  left: 3vw;
  width: 16vw;

  animation: ${bobbing} 7.7s ease-in-out -5s infinite;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const StarBackground1Image = styled.img`
  position: absolute;
  top: 35vw;
  left: 0vw;
  width: 14vw;

  animation: ${bobbing} 7s ease-in-out -1s infinite;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const PinkCharacterImage = styled.img`
  position: absolute;
  top: 28vw;
  left: 22vw;
  width: 20vw;

  animation: ${bobbing} 7.5s ease-in-out -4s infinite;

  @media (max-width: 600px) {
    z-index: 1;
    position: absolute;
    top: 85vw;
    left: 1vw;
    width: 28vw;
  }
`;

export const SmallStarImage = styled.img`
  position: absolute;
  top: 30vw;
  left: 32vw;
  width: 18vw;

  animation: ${bobbing} 7.5s ease-in-out -4s infinite;
  
  @media (max-width: 600px) {
    z-index: 1;
    position: absolute;
    top: 91vw;
    left: 19vw;
    width: 18vw;
  }
`;

export const GhostCharacterImage = styled.img`
  position: absolute;
  top: 33vw;
  left: 68vw;
  width: 23vw;

  animation: ${bobbing} 8s ease-in-out -2s infinite;

  @media (max-width: 600px) {
    position: absolute;
    top: 86vw;
    left: 60vw;
    width: 26vw;
  }
`;

export const LettuceCharacter2Image = styled.img`
  position: absolute;
  top: 42vw;
  left: 48vw;
  width: 26vw;

  animation: ${bobbing} 6.5s ease-in-out -3s infinite;

  @media (max-width: 600px) {
    position: absolute;
    top: 96vw;
    left: 31.5vw;
    width: 43vw;
  }
`;

export const StarsBackgroundImage = styled.img`
  position: absolute;
  top: 25.5vw;
  left: 20vw;
  width: 78vw;
  z-index: -1;

  animation: ${pulsing} 20s ease-in-out -4s infinite;

  @media (max-width: 600px) {
    position: absolute;
    top: 365vw;
    left: 15vw;
    width: 78vw;
  }
`;
